export const ESIGNET_UI_BASE_URL = "https://esignet.sdec.mosip.net";

// export const MOCK_RELYING_PARTY_SERVER_URL = "http://localhost/api";
// export const REDIRECT_URI_USER_PROFILE = "http://localhost/feedback";
// export const REDIRECT_URI_REGISTRATION = "http://localhost/feedback";
// export const REDIRECT_URI = "http://localhost/feedback";

// export const MOCK_RELYING_PARTY_SERVER_URL = "http://localhost:8080";
// export const REDIRECT_URI_USER_PROFILE = "http://localhost:3000/feedback";
// export const REDIRECT_URI_REGISTRATION = "http://localhost:3000/feedback";
// export const REDIRECT_URI = "http://localhost:3000/feedback";

export const MOCK_RELYING_PARTY_SERVER_URL = "https://feedback.digieconcenter.gov.lk/api";
export const REDIRECT_URI_USER_PROFILE = "https://feedback.digieconcenter.gov.lk/feedback";
export const REDIRECT_URI_REGISTRATION = "https://feedback.digieconcenter.gov.lk/feedback";
export const REDIRECT_URI = "https://feedback.digieconcenter.gov.lk/feedback";

export const CLIENT_ID = "Sg_4L2t6wy57L8PzTJ673XXLIKn447hLyuIQtIrCu4A";
export const ACRS = "mosip:idp:acr:generated-code%20mosip:idp:acr:biometrics%20mosip:idp:acr:static-code";
export const SCOPE_USER_PROFILE = "openid%20profile%20resident-service";
export const SCOPE_REGISTRATION = "openid%20profile";
export const CLAIMS_USER_PROFILE = "%7B%22userinfo%22%3A%7B%22gender%22%3A%7B%22essential%22%3Atrue%7D%7D%2C%22id_token%22%3A%7B%7D%7D";
export const CLAIMS_REGISTRATION = "%7B%22userinfo%22%3A%7B%22gender%22%3A%7B%22essential%22%3Atrue%7D%7D%2C%22id_token%22%3A%7B%7D%7D";
export const SIGN_IN_BUTTON_PLUGIN_URL = "https://esignet.sdec.mosip.net/plugins/sign-in-button-plugin.js";
export const DISPLAY = "page";
export const PROMPT = "consent";
export const GRANT_TYPE = "authorization_code";
export const MAX_AGE = 21;
export const CLAIMS_LOCALES = "en";
export const DEFAULT_LANG = "en";
export const FALLBACK_LANG = "%7B%22label%22%3A%22English%22%2C%22value%22%3A%22en%22%7D"